/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ServicedeskCmdbObjectSchemaConfigurationType from '@jira/spa-apps__servicedesk-cmdb-object-schema-configuration/src/ConditionalRedirectOrRouteView.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskCmdbObjectSchemaConfiguration: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof ServicedeskCmdbObjectSchemaConfigurationType>(
		() =>
			import(
				/* webpackChunkName: "async-servicedesk-cmdb-object-schema-configuration", jiraSpaEntry: "async-servicedesk-object-schema-configuration" */ '@jira/spa-apps__servicedesk-cmdb-object-schema-configuration/src/ConditionalRedirectOrRouteView.tsx'
			),
	);

const ObjectSchemaConfiguration = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskCmdbObjectSchemaConfiguration}
		pageId="spa-apps/servicedesk/insight/cmdb-object-schema-configuration"
		shouldShowSpinner
	/>
);

export default ObjectSchemaConfiguration;
